import React, { useState, useEffect } from 'react';
import { Button, Card, Input, Select, Carousel, Col, Row} from 'antd';
import plantimage from './assets/plant.png'
import companylogo from './assets/logo.png'
import { FcDepartment } from "react-icons/fc";
  import { FaCheckCircle, FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa';


import { get_dept, reg_user, get_verified, get_login, get_landing_apps,sendVerifyCodeUserReq } from '../../api/api.js';



function Loginbox(){
  const devEnv = process.env.REACT_APP_IS_DEV
  const appUrl = process.env.REACT_APP_URL
  const { Option } = Select;
  const [email, setEmail] = useState('');
  const [department, setDepartment] = useState([]);
  const [apps, setApps] = useState([]);
  const [emailError, setEmailError] = useState(true);
  const [emailClassName, setEmailClassName] = useState('default-email');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [isShown,setShown] = useState(false);
  const [activeTabKey2, setActiveTabKey2] = useState('login');
  const [verificationCode, setVerificationCode] = useState('');
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [verifyDiv,setVerifyDiv] = useState(true);

  const validateEmail = (value) => {
    const emailRegex = /@ndsu\.edu$/i;
    const isValid = emailRegex.test(value);
    return isValid;
  };

  const handleEmailChange = (e) => {
    const inputValue = e.target.value;
    setEmail(inputValue);
    setEmailError(!validateEmail(inputValue));
    setEmailClassName('default-email'); // Reset class when input changes
  };

  const onEmailBlur = () => {
    if (emailError) {
      setEmailClassName('email-error-input');
    } else if (email === '') {
      setEmailClassName('default-email');
    } else {
      setEmailClassName('valid-email');
    }

  };

  const renderEmailMessage = () => {
    if (emailClassName === 'valid-email') {
      return <div className="text-green-500">Valid E-Mail.</div>;
    } else if (emailClassName === 'email-error-input') {
      return <div className="text-red-500">Please Provide NDSU E-Mail.</div>;
    } else if (emailClassName === 'default-email') {
      // return <div className="text-gray-500">No E-Mail Provided.</div>;
    }
  };


  const handleVerificationCodeChange = (e) => {
    const inputValue = e.target.value;
    setVerificationCode(inputValue);
  }

  const verifyCode = async () => {
    if (verificationCode === '' || verificationCode === undefined) {
      alert('No Verification Code');
    } else {
      try {
        const response = await get_verified(email, verificationCode);
        if (response.status === 200) {
          setActiveTabKey2('login'); 
          setVerificationCode('');
          setShowNotification(true);
          setNotificationMessage('Your Profile Has Been Verified. Please Contact the Ag Data Analytics Team to Enable Your Account');
          setVerifyDiv(!verifyDiv);
        } else {
          console.log(response);
          setShowNotification(true);
          // Format errors as a numbered list
          const allErrors = response.error
                            .map((err, index) => `${index + 1}. ${err.msg}\n`) // Removed space before \n
                            .join(''); // Since \n is already included in each mapped string, no need to join with \n again
                            setNotificationMessage(`The Following Problems Occurred in Verifying:\n${allErrors}`);
        }
      } catch (err) {
        throw err;
      }
    }
  }
  




const handleLogin = () => {
  // 1. Check if we have a specific Auth URL from K8s ConfigMap
  // 2. Fallback to a relative path for the standalone server
  const authEndpoint = process.env.REACT_APP_AUTH_SERVICE_URL || "/nexuslogin/";

  // 3. Construct the 'Return To' URL dynamically
  const currentOrigin = window.location.origin;
  const base = process.env.REACT_APP_ROUTER_BASE || "";
  const returnTo = `${currentOrigin}${base}/landing/`;

  // 4. Redirect
  // If authEndpoint is "/nexuslogin/", it stays on the same server.
  // If authEndpoint is "https://auth...", it jumps to the K8s Auth service.
  window.location.href = `${authEndpoint}?ReqOrigin=${encodeURIComponent(returnTo)}`;
};

/*const getApps =async ()=>{
	const data = await user_profile();
	console.log('Data obtained ',data)
	const params = new URLSearchParams(window.location.search);
	const accessToken = params.get("accessToken");
	if(accessToken){
	   params.delete("accessToken");
          // window.history.replaceState
	   window.history.replaceState({}, document.title, window.location.pathname + '?' + params.toString());
	   return accessToken;	
	}
	return null;

}*/

 /* const handleLogin = () => {
    const authWindow = window.open(
      '/nexuslogin/',
      'AuthWindow',
      'width=600,height=600'
    );
    const messageListener = (event) => {
       console.log('Origin ',event.origin);
       console.log('Data ',event.data.authenticated);

     //if (event.origin !== 'https://rongo.bigdata.ag.ndsu.edu') return;  

     if (event.data.authenticated) {
	console.log('Acccess Token ',event.data)
        const { accessToken } = event.data;  

        // Store the access token (e.g., in local storage, if needed)
        localStorage.setItem('accessToken', accessToken);
	}
	 //localStorage.setItem('testToken','ABCD')
         // console.log(accessToken);
	// console.log(appUrl)
        // Redirect the main window to the desired path
        //window.location.href = `https://souradip-dev.bigdata.ag.ndsu.edu/landing`;
        //window.location.href = 'https://souradip-dev.bigdata.ag.ndsu.edu/landing';  
        window.removeEventListener('message', messageListener);
      
    }  
    window.addEventListener('message', messageListener);
  };*/


  const signUp = () => {

 
    
   
    setShown(!isShown);
  
    };

  /*const casticketValidate = async()=>{
    const urlParams = new URLSearchParams(window.location.search);
    const ticket = urlParams.get('ticket');
    if (ticket!== null)
    try {
      const response = await get_login(ticket);
      console.log(response)
      if(response.status===200){
        const url = new URL(window.location.href);
        
        url.searchParams.delete('ticket');
        window.history.replaceState({},'',url.pathname);      
        window.location.replace(`${window.location.href}landing`)  
      } 
      else if(response.status!==200){
        setNotificationMessage(response.message)      
        setShowNotification(true);
      }
    }catch(err){console.log(err)}
  }*/


  const getDept = async () => {
    try {
      const response = await get_dept(); // Assuming get_dept is your API function
      const data = response.data
      //console.log('Department Data ',data)
      const departmentNames = data.map((item, i) => ({
        key: item.key,
        label: item.departmentname,
        value: item.departmentname,
      }));
      setDepartment(departmentNames);
    } catch (error) {
      // Handle any errors here
      console.error('Error fetching department data:', error);
    }
  };

  const onDepartmentChange = (selectedDepartment) => {
    setSelectedDepartment(selectedDepartment);
  }

  useEffect(() => {
    //casticketValidate();
    getDept();
   // getApps();
    	  
    /*const accessToken = getAccessTokenFromUrl();
    if (accessToken){
	localStorage.setItem("accessToken",accessToken);	 
	window.location.href="/landing"
    }
    else{
	//window.location.href="/"
	//alert("No Access Token");
	console.log("Access Token Not Found")
    }*/
   
  }, []); 
  useEffect(() => {
    // This useEffect will run on mount and every time `email` or `selectedDepartment` changes
    const updateButtonState = async () => {
      if (selectedDepartment !== '') {
        // Enable the button if email is valid and a department is selected
        setDisabled(false);
      } else {
        // Disable the button if email is not valid or no department is selected
        setDisabled(true);
      }
    };
  updateButtonState();
}, [email, selectedDepartment]); 

    
const onRegisterUser = async () => {
  const result = await reg_user(email, selectedDepartment);
  if (result.status === 200) {//setRegistrationResult(true); 
    setActiveTabKey2('verify');
    //setEmail(''); 
    setSelectedDepartment('');
    setNotificationMessage('');
    setVerifyDiv(verifyDiv);
  }else if(result.status!==200){
    setShowNotification(true)
    setNotificationMessage(result.message)
    setVerifyDiv(!verifyDiv);
  }
}

/*const sendVerificationCode=async()=>{
  if(email===null||email===undefined||email===''){
    setShowNotification(true); 
    setNotificationMessage('Please Enter Your Email To Receive Verification Code');
  }
  const result = await sendVerifyCodeUserReq(email);
  if(result.status===200){
    setShowNotification(true);
    setNotificationMessage(result.message);
  }
  
}*/
const handleButtonClick = () => {
  signUp();         // Trigger signUp function
  onRegisterUser(); // Trigger onRegisterUser function
  //sendVerificationCode();
};


    // return (<div> {get_apps}</div>)

    return (
        <div className='Login'> 
        <div className='Loginbox'> 
        
         <div className="flex flex-3 flex-col px-4 pt-28 pb-4 lg:px-6">
         {/* <div className="flex flex-1 flex-col px-6 py-12 lg:px-8"> */}
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <img
            alt="Nexuxhub"
            src={companylogo}
            className="mx-auto size-28"
          />
        </div>

        <div className= "mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
         
          <div className="space-y-6">
            

            <div className='mt-2 emailbox'>
              <label htmlFor="email" className="ml-11 block text-sm font-medium leading-6 text-gray-900">
                Email address
              </label>
              <div className="mt-2">
              
              <Input 
            placeholder="Enter Your NDSU Email"
            
            value={email}
            onBlur={onEmailBlur}
            onChange={handleEmailChange}
            className={`${emailClassName} w-[300px] h-[46.48px] ml-11 deptset z-10 mt-2 origin-top-right rounded-md bg-gray-50 transition focus:outline-none`}
          />

        <p className="mt-2 text-center text-xs mb-4">{renderEmailMessage()}</p>
       
         
              </div>
            </div>


            <div className="mt-32 mb-2 department">
            <label
     
        className="block mb-2 ml-11 text-sm font-medium text-gray-900">
        Department
      </label>

      {/* className={`${emailClassName} w-72 ml-12 deptset z-10 mt-2 origin-top-right rounded-md bg-amber-50/50 transition focus:outline-none`} */}
      

      <Select 
      placeholder="Select a Department"
      
       className= " w-[300px] h-[46.48px] deptset z-10 ml-11 mt-2 origin-top-right rounded-md   transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
       
            onChange={onDepartmentChange}
            prefix={<FcDepartment />} >
            
              
              
              
            {department.map((department) => (
              <Option key={department.key} value={department.key}>
                {department.label}
              </Option>
            ))}</Select>
       </div>
       <div>
              <div className='centerize mt-[30px]'>
              {!isShown && (<button
              type="button"
              
                className="buttonstyle buttonforreg"  disabled={disabled} onClick={handleButtonClick}>
                <span class="text" style={{"fontWeight":600}}>Register</span>
              </button>)
              }

              
              </div>

              {showNotification?< p className="text-center text-sm mb-10" style={{fontSize:"20px",fontWeight:"600",margin:"35px"}}>{notificationMessage}</p>:''}


              { isShown && (<div>



                { verifyDiv && (
                  <div>
            <div>
              <label htmlFor="email" className="block w-xs text-sm font-medium leading-6 text-gray-900 mb-4">
                You Will Receive Your Verification Code Shortly Over Email.
               

              </label>
              <label className="flex-auto items-center block text-sm font-medium leading-6 text-gray-900 text-center" >Enter your Verification Code.</label>
              <div className="mt-2">
                <input
                
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  required
                  autoComplete="email" 
                  onChange={handleVerificationCodeChange}
                  value={verificationCode}
                  className="block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            <div className='centerize'>
            <button

                className= "buttonstyle buttonforlogin mt-10" onClick={verifyCode}> <span class="text">Verify</span>                
              </button>
             
              </div></div>)}
             
            </div>)}

        

              {verifyDiv ? <div className="flex items-center justify-center my-4">
                  <div className="w-16 border-t border-gray-300"></div>
                  <span className="mx-2 text-gray-500" style={{"fontWeight":500}}>Already have access?</span>
                  <div className="w-16 border-t border-gray-300"></div>
                    </div>:''}

          
            </div>
          </div>


          <div className="centerize"> <button
                type="submit"
                className= "buttonstyle buttonforlogin " onClick={handleLogin} style={{"fontWeight":600}}> <span class="text">Bison Login</span>
              
             
    
                
              </button>
              </div>


        </div>
      </div>
      </div>

      <div className='loginpageimage'>

        <img className='loginimageprop' src={plantimage} alt="" />










      </div>

          
        
        
        
        
    


          
        </div>
    )
}

export default Loginbox;
